var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCDollars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5612C7.5 14.8499 8.54467 15.8945 9.83333 15.8945H12C13.3807 15.8945 14.5 14.7752 14.5 13.3945C14.5 12.0138 13.3807 10.8945 12 10.8945H10C8.61929 10.8945 7.5 9.77524 7.5 8.39453C7.5 7.01382 8.61929 5.89453 10 5.89453H12.1667C13.4553 5.89453 14.5 6.9392 14.5 8.22786M11 4.39453V5.89453M11 15.8945V17.3945M21 10.8945C21 16.4174 16.5228 20.8945 11 20.8945C5.47715 20.8945 1 16.4174 1 10.8945C1 5.37168 5.47715 0.894531 11 0.894531C16.5228 0.894531 21 5.37168 21 10.8945Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCDollars);
export default __webpack_public_path__ + "static/media/c_dollars.a92fddef9f617ca4641a531e82296a9b.svg";
export { ForwardRef as ReactComponent };